import React from 'react'
import './inicio.css'
import {Link} from 'react-router-dom'
import {
	Container,
	Row,
	Col
} from 'reactstrap'


class Inicio extends React.Component {
	render() {
		return (
			<div className="intro">
				<Container>
					<Row className="intro-container">
						<Col lg="12">
							<h2 className="ini-title">Calculadora de <br /> Pensão Alimentícia</h2>
							<p className="ini-subtitle">Não perca mais tempo fazendo os cálculos a mão <br /> nossa calculadora faz isso por você</p>
						</Col>
						<Col lg="12" className="buttons">
							<Link to="/prisao">
						  		<button className="dpe-btn">Prisão</button>
							</Link>
							<Link to="/penhora">
						  <button className="dpe-btn">Penhora</button>
							</Link>
							<Link to="/justificativa">
						  <button className="dpe-btn">Justificativa</button>
							</Link>
						</Col>
					</Row>
				</Container>
			</div>
			)	
	}
}

export default Inicio



// WEBPACK FOOTER //
// ./src/components/inicio/inicio.jsx